// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#a6aaae","menuTextActive":"#fff","subMenuTextActive":"#f4f4f5","menuBg":"#001529","menuHover":"#263445","subMenuBg":"#000c17","subMenuHover":"#001528"};